import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RosteringUser } from '../teacher-users.model';
import { RestoreDeletedType } from '@app/teacher-users/restore-deleted-dialog/restore-deleted-dialog.component';
import { marker } from '@colsen1991/ngx-translate-extract-marker';

@Component({
  selector: 'restore-deleted-confirm-dialog',
  templateUrl: './restore-deleted-confirm-dialog.component.html',
  styleUrls: ['./restore-deleted-confirm-dialog.component.scss'],
  standalone: false,
})
export class RestoreDeletedConfirmDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { users: RosteringUser[]; restoreType: RestoreDeletedType },
  ) {}

  getDialogTitle() {
    return this.data.restoreType === RestoreDeletedType.RESTORE_STAFF
      ? marker('Restore Deleted Staff')
      : marker('Restore Deleted Students');
  }

  getRestoreContentTitle() {
    return this.data.restoreType === RestoreDeletedType.RESTORE_STAFF
      ? marker("You're restoring the following staff:")
      : marker("You're restoring the following students:");
  }
}
